import { z } from 'zod';
/** Open a new technical-support incident: a subject + the first message. */
export const createSupportTicketSchema = z.object({
    subject: z.string().min(3, 'El asunto debe tener al menos 3 caracteres').max(150),
    body: z.string().min(10, 'Describe la incidencia (mínimo 10 caracteres)').max(4000),
});
/** Post a reply in an existing ticket thread (reporter or support). */
export const postSupportMessageSchema = z.object({
    body: z.string().min(1, 'El mensaje no puede estar vacío').max(4000),
});
/** Support: change a ticket's status. */
export const updateSupportTicketStatusSchema = z.object({
    status: z.enum(['open', 'closed']),
});
//# sourceMappingURL=support.schema.js.map